import React from 'react'

function Categories(){

    return(
        <>
            <div className="widget">
                <h5 className="sub-title">Pinned</h5>
                
                <ul>
                    <li><a href="/archive-2">PGP Keys</a></li>
                </ul>
            </div>
        </>
    )

}

export default Categories